import { MenuSectionProps } from "./BCAFooterMenu";
import { getBooleanValue } from "../Navigation/navigation.functions";

export function buildSections(apiModel: any): MenuSectionProps[] {
  if (apiModel && apiModel["@nodes"]) {
    return apiModel["@nodes"].map((node: any) => {
      const section = apiModel[node];

      if (section && section["@nodes"].length > 0) {
        const sectionNodes: any[] = section["@nodes"];
        const titleNode = sectionNodes.filter(
          (node) => section[node] && getBooleanValue(section[node].isCategory)
        )[0];

        const menuSection: MenuSectionProps = {
          id: section[titleNode] ? section["@id"] : "",
          label: section[titleNode] ? section[titleNode].label : "",
        };

        menuSection.children = sectionNodes
          .filter((node) => node !== titleNode && section[node])
          .map((node) => {
            const child = section[node];

            return {
              id: child["@id"],
              openInNewWindow: getBooleanValue(child.openInNewWindow),
              label: child.label,
              link: child.link,
              isVisible: getBooleanValue(child.isVisible),
            };
          });

        return menuSection;
      }
      return {};
    });
  }

  return [];
}
